import useDuplicateProduct from "../../../../../clients/products/useDuplicateProduct";
import useCanEditBrand from "../../../../../clients/users/useCanEditBrand";

export default function useProductSaveAs(product) {
    const [duplicate] = useDuplicateProduct();

    const canEdit = useCanEditBrand(product?.data?.brand?.id);
    if (!canEdit) return () => {};

    return async function saveAs() {
        const result = await duplicate({
            variables: {
                selector: { id: product?.id },
                naturalKey: crypto.randomUUID(),
                suffix: false,
            },
        });

        if (result.data?.duplicateProduct.errors?.length) {
            console.error(result.data.duplicateProduct.errors);
            return;
        }

        const newProductID = result.data?.duplicateProduct.product?.id;
        if (newProductID) {
            window.open(`/products/Product/${newProductID}`, "_blank");
        }
    };
}
